type typeEvent = 'OPEN_EXTERNAL_LINK'

export const postMessageToNative = (
	type: typeEvent,
	data?: Record<string, any>,
): void => {
	if (typeof window !== 'undefined' && window.ReactNativeWebView) {
		try {
			window.ReactNativeWebView.postMessage(JSON.stringify({ type, ...data }))
		} catch (error) {
			console.error('Failed to post message to React Native WebView:', error)
		}
	}
}
